import React, { useState, useEffect } from 'react';
import LoadingBar from "react-top-loading-bar";
import { OrderTable, SubStatus } from "./components";
import { isAuthenticated } from '../../store/action/auth';
import Formatter from './helpers/formatter';
import HelperStatus from './helpers/status';
import moment from 'moment';
import { ListGroup, Nav } from 'react-bootstrap'
import { getAdminInfo } from '../../store/action/admin';
import Modal from "../../components/molecules/Modal"
import Header from "./components/Header";
import QRCode from "qrcode.react";
import { statusGroup } from "./constants";
import {
  getOrders,
  getDownloadOrders,
  confirmBatchOrder,
  deleteBatchOrder,
  fetchPaymentData
} from '../../store/action/order';
import FilterAction from '../../store/action/filter';
import MoreButton from './components/MoreButton';
import {getUser, updateUserOnLocal} from "../../store/action/user";
import PaymentWarning from "../../components/warnings/Payment";
import TestDataWarning from "../../components/warnings/TestData";
import ReactLoading from "react-loading";
import {connect, useDispatch} from "react-redux";
import {getWallet} from "../../store/action/billing";


const Order = (props) => {
  const dispatch = useDispatch();
  const pendingStatus = ['pending']
  const preStatus = ['placed','scheduled']
  const endStatus = ['cancelled','delivered','courierNotFound','rejected'];
  const activeStatus = ['confirmed','allocated','pickingUp','picked','droppingOff','onHold'];
  const allStatus = [...pendingStatus,...preStatus,...endStatus,...activeStatus]
  const { user, token } = isAuthenticated();
  const [ progress, setProgress ] = useState(0);
  const [ qrCode, setQrCode ] = useState('');
  const [ totalPage, setTotalPage ] = useState(1);
  const initialFilters = {
    statusFilterActive:false,
    limit: 50,
    page: 1,
    createdStartDate: moment().add(-30,'days').format("YYYY-MM-DD"),
    createdEndDate: moment().add(1,'days').format("YYYY-MM-DD"),
    confirmedStartDate: null,
    confirmedEndDate: null,
    tags:[],
    couriers:[],
    status:[]
  };
  const [ filters, setFilters ] = useState(initialFilters);

  const [ loadings, setLoadings ] = useState({
    message:'',
    order:false,
    origin:false,
    destination:false,
    couriers:false,
    view:false,
    filter:false,
    moreData:false
  });
  const [ show, setShow ] = useState({
    modal:false,
    modalType:'order',
    map:false,
    mapType:'origin',
    qr:false,
    qrType:'origin'
  });

  const [ values, setValues ] = useState({
    activeOrders:[],
    cancelReasons:[],
    cancellationReason:'',
    details:'',
    downloadOrders:[],
    downloadLoading:false,
    error:false,
    filteredOrders:[],
    filteredStatus:activeStatus,
    filterType:'preview',
    information:'',
    loading: true,
    loadingMoreData:false,
    ordersSelected:false,
    orders:[],
    page:1,
    paymentMethod:'',
    status:'active',
    statusTab:'active',
    groupStatus:statusGroup,
    success:false,
    tab:'active',
    tabOrderCount:{pending:0,preActive:0,active:0,notActive:0},
  });

  useEffect(() => {
    _fetchData();
  }, []);

  const _fetchData = async () => {
    const resOr = await getOrdersByFilters(filters);
    const resIn = await getAdminInfo(token);
    const resUs = await getUser(user._id, token);
    addProgress(20);
    if(resOr.success && resUs.success) {
      dispatch(getWallet(token));
      updateUserOnLocal({
        firstName: resUs.first_name,
        lastName:resUs.last_name,
        email: resUs.email,
        phone: resUs.phone,
        role: resUs.role,
        organization:{
          name: resUs.organization.name,
          bankAccounts:resUs.organization.bank_accounts,
        },
        integrations:resUs.integrations,
        cashOnDelivery:resUs.cash_on_delivery,
        insurances:resUs.insurances,
        walletType: resUs.wallet_type,
        balance:resUs.balance,
        paymentStatus: resUs.payment_status,
        paymentDueDate: resUs.payment_due_date,
        couriers: resUs.couriers,
        type:resUs.type
      },()=>{});
      
      const newFilteredOrders = resOr.orders.filter(i => activeStatus.includes(i.status));
      const formattedStatus = Formatter.orderNumberByStatus(resOr.order_by_status);
      setValues({
        ...values,
        loading:false,
        information:resIn.admin.information,
        details:resIn.admin.details,
        status:resIn.admin.status,
        orders:resOr.orders,
        filteredOrders:newFilteredOrders,
        groupStatus:formattedStatus,
        tabOrderCount:formattedStatus
      });

    } else {
      setLoadings({...loadings,view:false,message:''})
      return alert("Gagal mengambil data. Coba refresh atau ulangi beberapa saat lagi")
    }
    progressComplete();
  };

  const getOrdersByFilters = async f => {
    const resp = await getOrders(f);
    
    if (!resp.success) return alert('Failed get order')
    
    let orders = resp.orders.reduce((result, i, idx) => {
        result.push(Formatter.APItoOrder(i));
        return result
    }, []);

    orders = orders.sort((a, b) => {
        var dateA = new Date(a.deliveryDate);
        var dateB = new Date(b.deliveryDate);
        return dateB - dateA;
    });

    if (resp.total_page) setTotalPage(resp.total_page);

    return { success:true, ...resp, orders}
  };

  const addProgress = value => {
    setProgress(value);
  };

  const progressComplete = () => {
    setProgress(100);
  };

  const onClickPayment = async (idx,data) => {
    let orderCopy = values.filteredOrders;
    orderCopy[idx]['loading'] = true;
    setValues({...values,filteredOrders:orderCopy});
    setShow({...show});
    const res = await fetchPaymentData(token, data.orderId);
    if (!res.success) {
      alert(`Failed to get QR Code`);
      return
    }
    setQrCode(res.qr_string);
    setShow({ ...show, qr:true, modal:false});
    orderCopy[idx]['loading'] = false;
    setValues({...values,filteredOrders:orderCopy});
  }

  const onClickCheckBox = (t,e,idx) => {
    const copyValues = values.filteredOrders;
    if (t === 'header'){
      let checkSelected = copyValues.filter(i => i.selected);
      if (checkSelected.length > 0 && checkSelected.length !== copyValues.length) {
        copyValues.map(i => {
          i.selected = true;
        })
      } else {
        copyValues.map(i => {
          i.selected = !i.selected;
        })
      }
    } else {
      copyValues[idx].selected = !copyValues[idx].selected;
    }
    setValues({...values,filteredOrders:copyValues});
  };

  const onConfirmBatchOrder = async (orders) => {
    let message;
    if(window.confirm('Kami akan segera mempesan order kamu. Kamu yakin?')) {
      setLoadings({...loadings, view:true, message:'Membuat Order...'});
      confirmBatchOrder(token, orders)
          .then(res => {
            if (res.failedOrders > 0 && res.successOrders > 0) {
              message = `${res.successOrders} Pesanan Berhasil dikonfirmasi. ${res.failedOrders} Pesanan gagal dikonfirmasi. `
            } else if (res.failedOrders > 0 && res.successOrders === 0) {
              message = `${res.failedOrders} Pesanan gagal dikonfirmasi.`
            } else if (res.failedOrders === 0 && res.successOrders > 0) {
              message = `${res.successOrders} Pesanan Berhasil dikonfirmasi.`
            }
            alert(message);
            window.location.reload()
          });
    }
  };

  const onDeleteBatchOrder = async (orders) => {
    let message;
    if(window.confirm('Pesanan Anda akan segerra di cancel. Kamu yakin?')) {
      setLoadings({...loadings, view:true, message:'Membatalkan Order...'});
      deleteBatchOrder(token, orders)
          .then(res => {
            if (res.failedOrders > 0 && res.successOrders > 0) {
              message = `${res.successOrders} Pesanan Berhasil dicancel. ${res.failedOrders} Pesanan gagal dicancel. `
            } else if (res.failedOrders > 0 && res.successOrders === 0) {
              message = `${res.failedOrders} Pesanan gagal dicancel.`
            } else if (res.failedOrders === 0 && res.successOrders > 0) {
              message = `${res.successOrders} Pesanan Berhasil dicancel.`
            }
            alert(message);
            window.location.reload()
          });
    }
  };

  const infoSection = () => {
    if(values.status !== 'active') {
      return (
        <div className={`alert ${values.status === 'biteship' ? 'alert-info':'alert-warning'}`} role="alert">
          <p className="mb-0"><strong>{values.information}</strong></p>
          <p className="mb-0">{values.details}</p>
        </div>
      );
    }
  };

  const onCloseQR = () => {
    setShow({ ...show, qr:false, modal:false})
  };

  const modalQr = () => {
    return (
        <Modal
            show={show.qr}
            onHide={onCloseQR}
            title={"Pembayaran QRIS"}
            size={"sm"}
            bodyClassName="py-4 text-center"
            buttons
        >
          <p> Silahkan lakukan pembayaran dengan scan QR code dibawah ini </p>
          <QRCode
              size={156}
              value={qrCode}
          />
          <br/>
          <p> Pembayaran QRIS dengan <b>scan QR Code</b> melalalui aplikasi OVO, Gojek, LinkAja dan lainnya yang mendukung teknologi QRIS.</p>
        </Modal>
    )
  };

  const tabToStatusView = (tab) => {
    let selectedStatus;
    if (tab === 'pending') {
      selectedStatus = ['pending']
    } else if (tab === 'preActive') {
      selectedStatus = preStatus;
    } else if (tab === 'active') {
      selectedStatus = activeStatus;
    } else if (tab === 'notActive') {
      selectedStatus = endStatus;
    } else {
      selectedStatus = [tab];
    }
    return selectedStatus
  }

  const onChangeStatusTab = async (tab) => {
    setValues({...values,loading:true})
    const selectedStatus = tabToStatusView(tab);
    let newFilters;
    if (filters.statusFilterActive) {
      if (HelperStatus.isGroupStatus(tab)) {
        newFilters = {...filters,page:1,status:values.filteredStatus}
      } else if (values.tabOrderCount[tab] > 0) {
        newFilters = {...filters,page:1,status:selectedStatus}
      } else {
        newFilters = {...filters,page:1}
      }
    } else {
      newFilters = {...filters,page:1,status:selectedStatus}
    }
    const responseOrders = await getOrdersByFilters(newFilters);
    const newFilteredOrders = responseOrders.orders.filter(i => selectedStatus.includes(i.status));

    setValues({
      ...values,
      page:1,
      loading:false,
      filteredOrders:newFilteredOrders,
      statusTab:tab
    })
    setFilters({
      ...filters,
      page:newFilters.page
    })
  }

  const onClickTab = async (tab) => {
    setValues({...values, loading:true})
    const selectedStatus = tabToStatusView(tab);
    let newFilters;
    if (filters.statusFilterActive) {
      if (HelperStatus.isGroupStatus(tab)) {
        newFilters = {...filters,page:1,status:values.filteredStatus}
      } else if (values.tabOrderCount[tab] > 0) {
        newFilters = {...filters,page:1,status:selectedStatus}
      } else {
        newFilters = {...filters,page:1}
      }
    } else {
      newFilters = {...filters,page:1,status:selectedStatus}
    }
    const responseOrders = await getOrdersByFilters(newFilters);
    const newFilteredOrders = responseOrders.orders.filter(i => selectedStatus.includes(i.status));
    setValues({
      ...values,
      page:1,
      loading:false,
      filteredOrders:newFilteredOrders,
      statusTab:tab,
      tab:tab
    });
    setFilters({
      ...filters,
      page:newFilters.page
    })
  };

  const formatFilters = (nf) => {
    if (nf.status.length > 0) {
      return ({ ...filters, ...nf, statusFilterActive:true, page:1 })
    } else {
      return ({ ...filters, ...nf, statusFilterActive:false, page:1 })
    }
  };

  const onPreviewFilter = async (nf) => {
    setValues({...values,loading:true});
    const newFilters = formatFilters(nf);  
    const response = await getOrdersByFilters(newFilters);
    const selectedStatus = tabToStatusView(values.tab);
    const newFilteredOrders = response.orders.filter(i => selectedStatus.includes(i.status));
    const formattedStatus = Formatter.orderNumberByStatus(response.order_by_status);
    setValues({
      ...values,
      loading:false,
      downloadOrders:[],
      page:newFilters.page,
      statusTab:values.tab,
      orders:response.orders,
      groupStatus:formattedStatus,
      tabOrderCount:formattedStatus,
      filteredOrders:newFilteredOrders,
      filteredStatus:newFilters.status,
      filterType:'preview'
    });
    setFilters(newFilters);
  };

  const onSubmitFilters = async (name,nf) => {
    setValues({...values,loading:true});
    const newFilters = formatFilters(nf)
    const savedFilter = await FilterAction.createFilter(name,newFilters);
    if (!savedFilter.success) {return alert("Failed to save filter")};
    const response = await getOrdersByFilters(newFilters);
    const selectedStatus = tabToStatusView(values.tab);
    const newFilteredOrders = response.orders.filter(i => selectedStatus.includes(i.status));
    const formattedStatus = Formatter.orderNumberByStatus(response.order_by_status);
    setValues({
      ...values,
      loading:false,
      downloadOrders:[],
      page:newFilters.page,
      statusTab:values.tab,
      orders:response.orders,
      groupStatus:formattedStatus,
      tabOrderCount:formattedStatus,
      filteredOrders:newFilteredOrders,
      filteredStatus:newFilters.status,
      filterName:name,
      filterType:'save'
    });
    setFilters(newFilters);
    alert(`Fitler tersimpan dengan nama "${name}"`);
  };
  
  const onClickMoreOrders = async () => {
    setValues({...values,loadingMoreData:true});
    const selectedStatus = tabToStatusView(values.statusTab);
    let newFilters;
    if (filters.statusFilterActive) {
      if (HelperStatus.isGroupStatus(values.statusTab)) {
        newFilters = {...filters,status:values.filteredStatus}
      } else if (values.tabOrderCount[values.tab] > 0) {
        newFilters = {...filters,status:selectedStatus}
      } else {
        newFilters = {...filters}
      }
    } else {
      newFilters = {...filters,status:selectedStatus}
    }

    newFilters = { ...newFilters, page:filters.page+1};
    const response = await getOrdersByFilters(newFilters);
    const newOrders = [...values.filteredOrders,...response.orders]
    const newFilteredOrders = newOrders.filter(i => selectedStatus.includes(i.status));
    setValues({
      ...values,
      loadingMoreData:false,
      page:newFilters.page,
      orders:newOrders,
      filteredOrders:newFilteredOrders,
    })
    setFilters(newFilters);
  }

  const onDownloadOrders = async () => {
    setValues({...values,downloadLoading:true});
    const resp = await getDownloadOrders(filters);
    if (!resp.success) {
      alert(resp.error);
      setValues({...values,downloadLoading:false});
      return;
    };
    setValues({
      ...values,
      downloadLoading:false, 
      downloadOrders:Formatter.dataToDownload(resp.orders)
    });
  }

  const nav = () => {
    return (
        <Nav variant="tabs" className="px-4" defaultActiveKey="active">
          {
            values.tabOrderCount.pending > 0 ?
                <Nav.Item className="col-2 px-0 text-center">
                  <Nav.Link eventKey="pending" onSelect={() => onClickTab('pending')}>
                    PENDING {values.tabOrderCount.pending ? "("+values.tabOrderCount.pending+")" : null}
                  </Nav.Link>
                </Nav.Item> : null
          }
          <Nav.Item className="col-2 px-0 text-center">
            <Nav.Link eventKey="preActive" onSelect={() => onClickTab('preActive')}>
              TERSIMPAN {values.tabOrderCount.preActive ? "("+values.tabOrderCount.preActive+")" : null}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="col-2 px-0 text-center">
            <Nav.Link eventKey="active" onSelect={() => onClickTab('active')}>
              BERLANGSUNG {values.tabOrderCount.active ? "("+values.tabOrderCount.active+")" : null}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="col-2 px-0 text-center">
            <Nav.Link eventKey="notActive" onSelect={() => onClickTab('notActive')}>
              SELESAI {values.tabOrderCount.notActive ? "("+values.tabOrderCount.notActive+")" : null}
            </Nav.Link>
          </Nav.Item>
        </Nav>
    )
  };

  if (user.paymentStatus === 'debt') {
    return (
        <PaymentWarning user={user} type={"content"}/>
    )
  }

  const loadingView = () => {
    return (
        <div className="text-center row">
          <div className="col-3"/>
          <div className="row col-5 py-5">
            <ReactLoading
                type={'bubbles'}
                color={'#459BD8'}
                height={54}
                width={75}
            />
            <h5 className="mt-4 "><strong> mengambil order</strong></h5>
          </div>
          <div className="col-4"/>
        </div>
    );
  }

  return (
      <div className="mb-4">
        <PaymentWarning user={user} type={"top"}/>
        <TestDataWarning/>
        <div className="bg-white rounded shadow mb-4">
          <LoadingBar progress={progress} color='#059fe6' height={5}/>
          { infoSection() }
          { modalQr() }
          <Header 
            user={user}
            data={values.downloadOrders}
            filterTitle={values.filterName}
            loadingDownload={values.downloadLoading}
            onClickDownload={onDownloadOrders}
            onPreviewFilter={onPreviewFilter}
            onSubmitFilters={onSubmitFilters}
          />
          { nav() }
          <SubStatus 
            loading={values.loading}
            onClick={e => onChangeStatusTab(e)} 
            tab={values.tab}
            status={values.statusTab}
            statusValues={values.groupStatus}
          />
          {
            values.loading ? loadingView() :
              <OrderTable
                data={values.filteredOrders}
                loading={values.loading}
                tab={values.tab}
                onClickPayment={onClickPayment}
                onClickCheckBox={onClickCheckBox}
                onConfirmBatchOrder={onConfirmBatchOrder}
                onDeleteBatchOrder={onDeleteBatchOrder}
              />
          }
        </div>
        <MoreButton 
            data={values.tabOrderCount}
            statusTab={values.statusTab}
            totalOrders={values.filteredOrders.length}
            limit={filters.limit}
            page={values.page}
            loading={values.loadingMoreData}
            loadingView={values.loading}
            onClick={onClickMoreOrders} 
        />
      </div>
  )
};

export default connect(state => ({ wallet: state.wallet}), {})(Order)
